import { TraceabilityStatus } from "@/enums"

export const brazilianFederativeUnitsAcronyms = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
]

export const brazilianFederativeUnits = [
  "Acre",
  "Alagoas",
  "Amapá",
  "Amazonas",
  "Bahia",
  "Ceará",
  "Distrito Federal",
  "Espírito Santo",
  "Goiás",
  "Maranhão",
  "Mato Grosso",
  "Mato Grosso do Sul",
  "Minas Gerais",
  "Pará",
  "Paraíba",
  "Paraná",
  "Pernambuco",
  "Piauí",
  "Rio de Janeiro",
  "Rio Grande do Norte",
  "Rio Grande do Sul",
  "Rondônia",
  "Roraima",
  "Santa Catarina",
  "São Paulo",
  "Sergipe",
  "Tocantins",
]

export const traceabilityStatusLabels = {
  [TraceabilityStatus.WaitingForWithdrawal]: 'Aguardando retirada',
  [TraceabilityStatus.InTransit]: 'Em trânsito',
  [TraceabilityStatus.Triage]: 'Triagem',
  [TraceabilityStatus.InExecution]: 'Em execução',
  [TraceabilityStatus.InRelease]: 'Em liberação',
  [TraceabilityStatus.ReportReleased]: 'Laudo liberado',
  [TraceabilityStatus.WithPending]: 'Com pendência',
  [TraceabilityStatus.WithdrawalRequested]: 'Solicitada coleta',
  [TraceabilityStatus.Recollection]: 'Coletado',
  [TraceabilityStatus.Marked]: 'Remarcado',
  [TraceabilityStatus.ReportViewed]: 'Laudo visualizado',
  [TraceabilityStatus.ExamCanceled]: 'Exame cancelado',
  [TraceabilityStatus.Finalized]: 'Finalizado',
  [TraceabilityStatus.SampleDiscarded]: 'Amostra descartada',
  [TraceabilityStatus.Recalled]: 'Reconvocado',
  [TraceabilityStatus.RecalledText]: 'Recoleta',
  [TraceabilityStatus.SampleObtained]: 'Amostra obtida',
  [TraceabilityStatus.NotPhysicallyBatched]: 'Não loteada fisicamente',
  [TraceabilityStatus.Canceled]: 'Cancelado',
  [TraceabilityStatus.NotTracked]: 'Não rastreado',
  [TraceabilityStatus.WithdrawalExpired]: 'Retirada expirada',
  [TraceabilityStatus.NotReceived]: 'Não recebida',
  [TraceabilityStatus.InTransitBetweenNTOs]: 'Em trânsito entre NTO',
  [TraceabilityStatus.Registered]: 'Cadastrado',
  [TraceabilityStatus.CanceledByClient]: 'Cancelado pelo cliente',
  [TraceabilityStatus.NotSent]: 'Não enviada',
  [TraceabilityStatus.PendingCreated]: 'Pendência criada',
  [TraceabilityStatus.PendingCreatedText]: 'Pendência',
  [TraceabilityStatus.PendingAnswered]: 'Pendência respondida',
  [TraceabilityStatus.Issued]: 'Emitido',
}

/** @note Created to handle exceptional data that are treated as statuses, but are not. */
export const traceabilityExceptionalStatusLabels = {
  behindSchedule: 'Exames em atraso',
  aheadSchedule: 'Exames adiantados',
};

export const traceabilityStatusColors = {
  [TraceabilityStatus.WaitingForWithdrawal]: '#76D692',
  [TraceabilityStatus.InTransit]: '#76D692',
  [TraceabilityStatus.Triage]: '#76D692',
  [TraceabilityStatus.InExecution]: '#76D692',
  [TraceabilityStatus.InRelease]: '#76D692',
  [TraceabilityStatus.ReportReleased]: '#32A454',
  [TraceabilityStatus.WithPending]: '#F5A623', /** @todo Confirm color. */
  [TraceabilityStatus.WithdrawalRequested]: '#F5A623', /** @todo Confirm color. */
  [TraceabilityStatus.Recollection]: '#F5A623',
  [TraceabilityStatus.Marked]: '#F5A623', /** @todo Confirm color. */
  [TraceabilityStatus.ReportViewed]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.ExamCanceled]: '#919191',
  [TraceabilityStatus.Finalized]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.SampleDiscarded]: '#919191', /** @todo Confirm color. */
  [TraceabilityStatus.Recalled]: '#F5A623', /** @todo Confirm color. */
  [TraceabilityStatus.SampleObtained]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.NotPhysicallyBatched]: '', /** @todo Confirm color. */
  [TraceabilityStatus.Canceled]: '#919191',
  [TraceabilityStatus.NotTracked]: '#87003F',
  [TraceabilityStatus.WithdrawalExpired]: '#919191', /** @todo Confirm color. */
  [TraceabilityStatus.NotReceived]: '#87003F',
  [TraceabilityStatus.InTransitBetweenNTOs]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.Registered]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.CanceledByClient]: '#919191',
  [TraceabilityStatus.NotSent]: '#87003F',
  [TraceabilityStatus.PendingCreated]: '#F5A623', /** @todo Confirm color. */
  [TraceabilityStatus.PendingAnswered]: '#76D692', /** @todo Confirm color. */
  [TraceabilityStatus.Issued]: '#76D692', /** @todo Confirm color. */
}

/** @note Created because some endpoints are returning the statuses in English. */
export const traceabilityStatusAlternativeNamesMap = {
  IN_EXECUTION: TraceabilityStatus.InExecution,
  DEPENDENCE: TraceabilityStatus.PendingCreatedText,
  ANSWER_DEPENDECE: TraceabilityStatus.PendingAnswered,
  TO_RELEASED: TraceabilityStatus.InRelease,
  RECALL: TraceabilityStatus.RecalledText,
  REPORT_RELEASED: TraceabilityStatus.ReportReleased,
  DELIVERY_TO_NTO: TraceabilityStatus.Triage,
  WAITING: TraceabilityStatus.WaitingForWithdrawal,
  IN_TRANSFER: TraceabilityStatus.InTransit,
  IN_TRANSFER_NTO: TraceabilityStatus.InTransitBetweenNTOs,
  CANCELED: TraceabilityStatus.Canceled,
}

export const ONE_SECOND_IN_MILLISECONDS = 1_000

export const ONE_MINUTE_IN_MILLISECONDS = ONE_SECOND_IN_MILLISECONDS * 60

export const PATERNITY_CODES = ['PATMATER', 'PAT', 'PATDUO', 'PATRECONS']

export const isPaternityExam = (mnemonic) => PATERNITY_CODES.includes(mnemonic)

export const isPaternityOrder = (mnemonics) => mnemonics.some(mnemonic => PATERNITY_CODES.includes(mnemonic))
